var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("gg-modal", {
    attrs: {
      "is-active": _vm.dialogState
    },
    on: {
      close: _vm.close
    },
    scopedSlots: _vm._u([
      {
        key: "toolbar",
        fn: function fn() {
          return [_vm._v(" IP Address ")]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function fn() {
          return [
            _c(
              "form",
              [
                _c("v-text-field", {
                  attrs: {
                    disabled: "",
                    outlined: "",
                    label: "IP Address"
                  },
                  model: {
                    value: _vm.ip_record,
                    callback: function callback($$v) {
                      _vm.ip_record = $$v
                    },
                    expression: "ip_record"
                  }
                }),
                _c("v-text-field", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|url",
                      expression: "'required|url'"
                    }
                  ],
                  attrs: {
                    outlined: "",
                    label: "PTR",
                    name: "PTR",
                    "error-messages": _vm.errors.collect("PTR")
                  },
                  model: {
                    value: _vm.ptr,
                    callback: function callback($$v) {
                      _vm.ptr = $$v
                    },
                    expression: "ptr"
                  }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "actions",
        fn: function fn() {
          return [
            _c(
              "gg-btn",
              {
                attrs: {
                  secondary: ""
                },
                on: {
                  click: _vm.close
                }
              },
              [_vm._v(" Cancel ")]
            ),
            _c(
              "gg-btn",
              {
                attrs: {
                  primary: "",
                  loading: _vm.loading
                },
                on: {
                  click: _vm.save
                }
              },
              [_vm._v(" Save ")]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }